import React, { useState } from 'react';
import { RiShare2Fill } from 'react-icons/ri';

// ChatMessage Component
const ChatMessage = ({ avatar, name, time, message, photo }) => (
    <div className="chat-box">
        <div className="flex space-between">
            <div className="flex flex-v-center">
                <img src={avatar} alt={name} className="member-avatar" />
                <strong>{name}</strong>
            </div>
            <p> - {time}</p>
        </div>
        <div className='chat-message col-7'>
            <p className='m-b-10'>{message}</p>
            {photo && <img src={photo} alt="chat visual" className="chat-photo center-text" />}
        </div>
    </div>
);

const Members = ({ avatar, name, mutuals }) => (
    <div className="friend-item">
        <div className="flex flex-v-center">
            <img src={avatar} alt={name} className="member-avatar" />
            <strong>{name}</strong>
        </div>
        <p>Mutuals {mutuals}</p>
    </div>
);

const Media = ({ photo }) => (
    <div className="chat-photo-container">
        <img src={photo} alt="media" className="chat-photo" />
    </div>
);

// SimilarGroup Component
const SimilarGroup = ({ image, name, details }) => (
    <div className="similar-group">
        <img src={image} alt={name} className="similar-group-img" />
        <div className="similar-group-info">
            <p className="similar-group-name">{name}</p>
            <p className="similar-group-details">{details}</p>
        </div>
    </div>
);

const CommunityGroupPage = () => {
    const [activeTab, setActiveTab] = useState("chat");

    const chatMessages = [
        {
            avatar: '/user-avater.png',
            name: 'Angel Harding',
            photo: '/bg-login.png',
            time: 'Friday 2:20pm',
            message: 'Hello! Thank you for allowing me to join this group!...',
            mutuals: 4,
        },
        {
            avatar: '/user-avater.png',
            name: 'Angel Harding',
            time: 'Friday 2:20pm',
            photo: '/bg-login.png',
            message: 'Dancing is a great way to reduce mental stress...',
            mutuals: 4,
        },

    ];

    const similarGroups = [
        {
            image: '/bg-login.png',
            name: 'Mental Wellness Hub',
            details: 'Public · 1.2k members',
        },
        {
            image: '/bg-login.png',
            name: 'Daily Positivity',
            details: 'Private · 900 members',
        },
    ];

    const renderContent = () => {
        switch (activeTab) {
            case "chat":
                return (
                    <div className="flex space-between">
                        <div className="chat-section w-50">
                            {chatMessages.map((msg, index) => (
                                <ChatMessage key={index} {...msg} />
                            ))}
                        </div>
                        <div className="w-40 no-margin">
                            <h3 className="similar-groups-title">Similar Groups</h3>
                            {similarGroups.map((group, index) => (
                                <SimilarGroup key={index} {...group} />
                            ))}
                        </div>
                    </div>
                );
            case "media":
                return (
                    <div className="chat-section w-100">
                        <h3 className='m-b-20'>Recent Media</h3>
                        {chatMessages.map((msg, index) => (
                            <Media key={index} {...msg} />
                        ))}
                    </div>
                );
            case "members":
                return (
                    <div className="chat-section w-50">
                        <div className="flex space-between  m-b-20 flex-v-center">
                            <div>
                                <h3>Members Of Group</h3>
                                <p className="group-meta">Public members: 560</p>
                            </div>
                            <div className="w-60 float-right ">
                                <div className="search-container ">
                                    <input type="text" placeholder="Search for Friends" />
                                    <span className="filter-icon">🔍</span>
                                </div>
                            </div>
                        </div>
                        {chatMessages.map((msg, index) => (
                            <Members key={index} {...msg} />
                        ))}
                    </div>
                );
            default:
                return null;
        }
    };

    return (
        <div className="community-container w-100">
            <div className="flex flex-direction-v">
                {/* Search Bar */}
                <div className="w-100">
                    <div className="search-container float-right w-40">
                        <input type="text" placeholder="Search for Groups" />
                        <span className="filter-icon">🔍</span>
                    </div>
                </div>
                {/* Group Banner */}
                <div className="upload-section m-b-40">
                    <div className="upload-box">
                        <p>
                            <strong>Click to upload</strong> or drag and drop
                        </p>
                        <p>JPG, JPEG, PNG less than 1MB</p>
                    </div>
                </div>
            </div>

            {/* Group Details */}
            <div className="community-header ">
                <h1 className="community-title">Mental Health Initiatives</h1>
                <p className="group-meta">Public. 560 members. 6 posts a year</p>
                <div className="flex space-between">
                    <div className="member-avatars">
                        <img src="/user-avater.png" alt="Member 1" className="member-avatar" />
                        <img src="/user-avater.png" alt="Member 2" className="member-avatar" />
                        <img src="/user-avater.png" alt="Member 3" className="member-avatar" />
                        <img src="/user-avater.png" alt="Member 4" className="member-avatar" />
                        <div className="more-members">+4</div>
                    </div>
                    <div className="group-actions float-right">
                        <button className="create-group-btn">+ Create a Post</button>
                        <button className="create-group-btn"><RiShare2Fill /> Share</button>
                        <button className="invite-members-btn">+ Invite Members</button>
                    </div>
                </div>
            </div>

            {/* Navigation Tabs */}
            <div className="com-tabs w-50">
                <div
                    className={`com-tab ${activeTab === "chat" ? "active" : ""}`}
                    onClick={() => setActiveTab("chat")}
                >
                    Chat
                </div>
                <div
                    className={`com-tab ${activeTab === "media" ? "active" : ""}`}
                    onClick={() => setActiveTab("media")}
                >
                    Media
                </div>
                <div
                    className={`com-tab ${activeTab === "files" ? "active" : ""}`}
                    onClick={() => setActiveTab("files")}
                >
                    Files
                </div>
                <div
                    className={`com-tab ${activeTab === "members" ? "active" : ""}`}
                    onClick={() => setActiveTab("members")}
                >
                    Members
                </div>
            </div>

            {/* Render Content Based on Active Tab */}
            {renderContent()}
        </div>
    );
};

export default CommunityGroupPage;
